// Compiled at 2026-10-07T06:21:14.844Z
// Auto-generated by Lowgile
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import { BoInfoSymbol, OnAfterCodeLoad, HasChangedInternallySymbol } from "@lg/shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty } from "@sumbricht/json-class-serializer";
import { proxySignal, ProxySignal, signal, computed, Signal } from "../../signals.js";
import { HasSignalProperties } from "@lg/shared";
import { immerable } from "immer";
import { DataLoader } from "@lg/shared";
import { Subject } from "rxjs";
import { z } from "zod";
import { AppContext } from "@lg/ng-shared";
import { ChangeDetectorRef } from "@angular/core";

const θdataLoader =
    new DataLoader(() => GoalSettingCycleStatus.loadInternal(), entryList => {
        GoalSettingCycleStatus.θentryList.set(entryList)
        GoalSettingCycleStatus.θonEntryListUpdated()
    }, { doCache: true, expireAfterMs: 0 })
    ;

// Auto-generated by Lowgile
export class GoalSettingCycleStatus {
    readonly [BoInfoSymbol] = Object.freeze({
        boType: "StaticEntity" as const,
        editablePropertyNames: ["id"] as const,
        computedPropertyNames: ["label"] as const,
        allPropertyNames: ["id", "label"] as const,
        propertyNamesOfInterest: [] as const,
    });
    readonly [HasSignalProperties] = true;
    readonly [HasChangedInternallySymbol] = new Subject<void>();
    readonly θid: ProxySignal<GoalSettingCycleStatus.Id | null>;
    static readonly Id = String;
    static ids: GoalSettingCycleStatus.Id[] = [] as any;
    static idsAndDisplayValues: Record<GoalSettingCycleStatus.Id, string> = {} as any;
    static θentryList = signal<GoalSettingCycleStatus.Entry[] | undefined>(this.θgetStaticEntryList());
    static θentryMap = computed(() => {
        const objEntries = this.θentryList()?.map(e => [e.id, e]) ?? []
        return Object.freeze(Object.fromEntries(objEntries))
    });
    static θchoicesCache = new Map<string, Sys.Types.Choice[]>();
    static θfilteredCache = new Map<string, Signal<GoalSettingCycleStatus.Entry[]>>();
    readonly θhasOthers = false;
    static readonly $displayProperty = 'label';
    [immerable] = true;
    readonly θlabel = computed(() => {
        const id = this.θid()
        return id !== null ? GoalSettingCycleStatus.getEntryMap()[id]?.label : undefined
    });
    readonly $isOther = false;

    static get [BoInfoSymbol]() {
        return GoalSettingCycleStatus[BoInfoSymbol]
    }

    get __type(): 'Toolbox.GoalSettingCycleStatus' {
        return 'Toolbox.GoalSettingCycleStatus'
    }

    set __type(_) {
    }

    static get __type(): 'Toolbox.GoalSettingCycleStatus' {
        return 'Toolbox.GoalSettingCycleStatus'
    }

    static set __type(_) {
    }

    @jsonProperty()
    get id(): GoalSettingCycleStatus.Id | null {
        return this.θid()
    }

    set id(id: GoalSettingCycleStatus.Id | GoalSettingCycleStatus | null) {
        if (id !== null && typeof id == 'object') { id = id.id }

        if (id != null && !GoalSettingCycleStatus.getEntry(id as GoalSettingCycleStatus.Id)) throw new Error('Invalid id for type Toolbox.GoalSettingCycleStatus: ' + id)
        this.θid.set(id as GoalSettingCycleStatus.Id | null)
        this[HasChangedInternallySymbol].next()
    }

    get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    static get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    get ids(): GoalSettingCycleStatus.Id[] {
        return GoalSettingCycleStatus.ids
    }

    get idsAndDisplayValues(): Record<GoalSettingCycleStatus.Id, string> {
        return GoalSettingCycleStatus.idsAndDisplayValues
    }

    get $displayValue(): string {
        return this.$isOther ? (this as any).$other : String((this as any)[GoalSettingCycleStatus.$displayProperty])
    }

    get label() {
        return this.θlabel()
    }

    get isFuture() {
        return this.id == 'future'
    }

    static get Future() {
        return new this('future')
    }

    get isOpen() {
        return this.id == 'open'
    }

    static get Open() {
        return new this('open')
    }

    get isClosed() {
        return this.id == 'closed'
    }

    static get Closed() {
        return new this('closed')
    }

    constructor(idOrObject: GoalSettingCycleStatus.Id | GoalSettingCycleStatus | null = null) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid = proxySignal(id)

    }

    getEntryList(filters?: { entryProperty: string, values: any[] }[]): GoalSettingCycleStatus.Entry[] {
        return This.GoalSettingCycleStatus.getEntryList(filters)
    }

    static getEntryList(filters?: { entryProperty: string, values: any[] }[]): GoalSettingCycleStatus.Entry[] {
        if (filters) {
            const key = JSON.stringify(filters)
            let filteredList = this.θfilteredCache.get(key)
            if (!filteredList) {
                filteredList = computed(() => this.θentryList()?.filter(entry => filters.every(filter => filter.values.includes(entry[filter.entryProperty]))) ?? [])
                this.θfilteredCache.set(key, filteredList)
            }

            return filteredList()
        }

        return this.θentryList()
    }

    static getEntryMap() {
        return this.θentryMap()
    }

    static getEntry(id: GoalSettingCycleStatus.Id) {
        const entryMap = this.getEntryMap()
        return entryMap[id]
    }

    static getChoices(labelColumn: keyof GoalSettingCycleStatus.Entry = '$displayValue'): Sys.Types.Choice[] {
        if (labelColumn == "$displayValue") labelColumn = GoalSettingCycleStatus.$displayProperty
        let options = this.θchoicesCache.get(labelColumn)
        if (!options) {
            const entryList = this.getEntryList() ?? []
            options = entryList.map(entry => ({ id: entry.id, label: String(entry[labelColumn]), $isOther: false }))
            this.θchoicesCache.set(labelColumn, options)
        }

        return options
    }

    static async load(forceReload = false) {
        if (forceReload) {
            this.θentryList.set(await θdataLoader.forceReloadAndGetData())
        } else {
            this.θentryList.set(await θdataLoader.waitAndGetValidData())
        }

        this.θonEntryListUpdated()
        return this.θentryList()
    }

    static async loadInternal(): Promise<GoalSettingCycleStatus.Entry[]> {
        const dynamicEntryList = []
        this.θchoicesCache.clear()
        return LowgileDataUtil.createReadonlyProxy(true, [...this.θgetStaticEntryList(), ...dynamicEntryList])
    }

    toJSON() {
        return this.id
    }

    $clone() {
        return new GoalSettingCycleStatus(this.id)
    }

    $equals(other: any) {
        if (this.id !== other?.id) return false

        return true
    }

    θtoPlainObject() {
        return this.id
    }

    θtoIdAndOther(idOrObject: GoalSettingCycleStatus.Id | GoalSettingCycleStatus | null) {
        if (idOrObject && typeof idOrObject == 'object') {
            return { id: idOrObject.id }

        } else {
            return { id: idOrObject as GoalSettingCycleStatus.Id | null, otherValue: '' }

        }
    }

    θupdate(idOrObject: GoalSettingCycleStatus.Id | GoalSettingCycleStatus) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid.set(id)

    }

    static θonEntryListUpdated() {
        this.ids = this.getEntryList().map(e => e.id)
        this.idsAndDisplayValues = Object.fromEntries(this.getEntryList().map(e => [e.id, e.$displayValue] as const)) as Record<GoalSettingCycleStatus.Id, string>
        AppContext.resolve(ChangeDetectorRef).detectChanges()
    }

    static async θafterCodeLoad() {
        return this.load().catch(err => {
            console.log('Could not load entries of StaticEntity Toolbox.GoalSettingCycleStatus yet:', err.message)
            //throw err
        })
    }

    static $getSchema() {
        return z.string()
    }

    $getSchema() {
        return z.string()
    }

    setFuture() {
        this.id = 'future'

    }

    setOpen() {
        this.id = 'open'

    }

    setClosed() {
        this.id = 'closed'

    }

    static θgetStaticEntryList() {
        return Object.freeze([
            Object.freeze({ id: "future", label: "Future" }),
            Object.freeze({ id: "open", label: "Open" }),
            Object.freeze({ id: "closed", label: "Closed" })
        ] as GoalSettingCycleStatus.Entry[]) as GoalSettingCycleStatus.Entry[]
    }
}
jsonClass('Toolbox.GoalSettingCycleStatus')(GoalSettingCycleStatus)

export const GoalSettingCycleStatusθId = String;

export type GoalSettingCycleStatusθId = string;

export namespace GoalSettingCycleStatus {
    export type Id = 'future' | 'open' | 'closed'

    export interface Entry {
        id: GoalSettingCycleStatus.Id;
        label: string;
        $displayValue?: string;
    }
}
Sys.Language.languageChanged$.subscribe(() => GoalSettingCycleStatus.load(true))
